import { Router } from '@angular/router';
import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";
import { DynamicDialogService } from '../Customer/dynamic-dialog/dynamic-dialog.service';
import * as moment from 'moment';

@Injectable({
    providedIn: "root"
})
export class IdleUserService {
    // Variable that defines the time in milliseconds after which the user will be logged out due to inactivity
    maxIdleTime: number = 15 * 60 * 1000;
    // maxIdleTime: number = 40 * 1000;

    // Variable that defines the time in milliseconds how long the message about the user's inactivity will be displayed
    maxMessageTime: number = 30 * 1000;

    idleTimer: ReturnType<typeof setTimeout>;
    countdownTimer: ReturnType<typeof setTimeout>;

    messageVisibleTimeout: ReturnType<typeof setTimeout>;
    messageSummary: string;

    minutesLeft: number = 1;
    minutesLeftInterval: ReturnType<typeof setTimeout>;
    secondsFromInitialize: number;

    constructor(
        private router: Router,
        private messageService: MessageService,
        private dynamicDialogService: DynamicDialogService
    ) { }

    initialize(): void {
        // Start the timer of the user's inactivity on initialization
        this.resetTimer();

        // Add event listeners for the user's activities to reset the timer
        // Remove the event listener on mousemove after the timer is reset and add it again after 1 second to prevent lagging
        const resetTimerMouseMove: () => void = (): void => {
            this.resetTimer();

            window.removeEventListener("mousemove", resetTimerMouseMove);

            setTimeout(() => {
                window.addEventListener("mousemove", resetTimerMouseMove);
            }, 1000);
        }

        this.secondsFromInitialize = new Date().getTime();

        window.addEventListener("mousemove", resetTimerMouseMove);
        window.addEventListener("click", () => this.resetTimer());
        window.addEventListener("keypress", () => this.resetTimer());
        window.addEventListener("mousewheel", () => this.resetTimer());
        window.addEventListener("touchmove", () => this.resetTimer());
    }

    // Reset the timer of the user's inactivity
    resetTimer(): void {
        clearTimeout(this.idleTimer);
        clearTimeout(this.countdownTimer);
        clearInterval(this.minutesLeftInterval);
        clearTimeout(this.messageVisibleTimeout);
        this.messageService.clear();

        // If the user is not on the login page, start the timer of the user's inactivity
        if (!this.router.url.includes("/login")) {
            if (this.minutesLeft > 1) {
                console.log("15 minutes left");
            }

            this.minutesLeft = 1;
            this.minutesLeftInterval = setInterval(() => {
                console.log(15 - this.minutesLeft + " minutes left");
                console.log(moment(new Date()).format("HH:mm"), Math.floor(new Date().getTime() / 1000 - this.secondsFromInitialize / 1000) + " seconds");
                this.minutesLeft++;
            }, 60 * 1000);

            this.idleTimer = setTimeout(() => {
                // Show the message about the user's inactivity and start the countdown to log out the user
                this.showMessage("error", "You will be logged out in " + this.maxMessageTime / 1000 + " seconds due to inactivity");
                console.log(new Date().toTimeString(), "You will be logged out in 30 seconds");
                this.startCountdown();
            }, this.maxIdleTime - this.maxMessageTime);
        }
    }

    // Start the countdown to log out the user
    startCountdown(): void {
        clearTimeout(this.countdownTimer);
        this.countdownTimer = setTimeout(() => {
            this.dynamicDialogService.closeDialog();
            clearInterval(this.minutesLeftInterval);
            this.router.navigate(["/login"], { state: { tokenExpired: true } });
        }, this.maxMessageTime);
    }

    // Show the message that the user will be logged out due to inactivity
    showMessage(severity: string, summary: string): void {
        clearTimeout(this.messageVisibleTimeout);

        if (document.querySelector(".ui-messages") && this.messageSummary != summary) {
            this.messageService.clear();

            this.messageService.add({ severity, summary });
            this.messageSummary = summary;
            this.messageVisibleTimeout = setTimeout(() => {
                this.messageService.clear();
            }, this.maxMessageTime);
        }
        else {
            if (document.querySelector(".ui-messages")) {
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, this.maxMessageTime);
            }
            else {
                this.messageService.add({ severity, summary });
                this.messageSummary = summary;
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, this.maxMessageTime);
            }
        }
    }
}
